// extracted by mini-css-extract-plugin
module.exports = {"user_update":"ChangePassword_user_update__29gJv","main":"ChangePassword_main__1_vrG","form":"ChangePassword_form__wSJ9U"};